export const projectCode = 'ambria_riverbend';
